const map = {
	"./Aliluja/Sunday/Glas1/ru.mdx": 40865,
	"./Aliluja/Sunday/Glas2/ru.mdx": 64084,
	"./Aliluja/Sunday/Glas3/ru.mdx": 55095,
	"./Aliluja/Sunday/Glas4/ru.mdx": 12714,
	"./Aliluja/Sunday/Glas5/ru.mdx": 66621,
	"./Aliluja/Sunday/Glas6/ru.mdx": 35760,
	"./Aliluja/Sunday/Glas7/ru.mdx": 28323,
	"./Aliluja/Sunday/Glas8/ru.mdx": 11366,
	"./Aliluja/WeekDays/1/ru.mdx": 89411,
	"./Aliluja/WeekDays/2/ru.mdx": 76586,
	"./Aliluja/WeekDays/3/ru.mdx": 72733,
	"./Aliluja/WeekDays/4/ru.mdx": 71028,
	"./Aliluja/WeekDays/5/ru.mdx": 23511,
	"./Aliluja/WeekDays/6/ru.mdx": 37246,
	"./Antifon1/ru.mdx": 70521,
	"./Antifon1Ascension/ru.mdx": 89322,
	"./Antifon1Christmas/ru.mdx": 81041,
	"./Antifon1Easter/ru.mdx": 71427,
	"./Antifon1Epiphany/ru.mdx": 72943,
	"./Antifon1Pentecost/ru.mdx": 42712,
	"./Antifon1Transfiguration/ru.mdx": 32145,
	"./Antifon1VhodGospoden/ru.mdx": 10721,
	"./Antifon1Vozdvijenie/ru.mdx": 6502,
	"./Antifon2/ru.mdx": 53004,
	"./Antifon2Ascension/ru.mdx": 20957,
	"./Antifon2Christmas/ru.mdx": 92930,
	"./Antifon2Easter/ru.mdx": 22334,
	"./Antifon2Epiphany/ru.mdx": 37898,
	"./Antifon2Pentecost/ru.mdx": 64451,
	"./Antifon2Transfiguration/ru.mdx": 97802,
	"./Antifon2VhodGospoden/ru.mdx": 89296,
	"./Antifon2Vozdvijenie/ru.mdx": 40833,
	"./Antifon3/ru.mdx": 20111,
	"./Antifon3Ascension/ru.mdx": 90900,
	"./Antifon3Christmas/ru.mdx": 50891,
	"./Antifon3Easter/ru.mdx": 10745,
	"./Antifon3Epiphany/ru.mdx": 53585,
	"./Antifon3Pentecost/ru.mdx": 3826,
	"./Antifon3Transfiguration/ru.mdx": 13819,
	"./Antifon3VhodGospoden/ru.mdx": 12019,
	"./Antifon3Vozdvijenie/ru.mdx": 49880,
	"./AntifonVsednev1/ru.mdx": 77274,
	"./AntifonVsednev2/ru.mdx": 94867,
	"./AntifonVsednev3/ru.mdx": 77184,
	"./BeforeGospel/ru.mdx": 4724,
	"./BlessBeforeGosp/ru.mdx": 38138,
	"./EktenyaOglashaemie/ru.mdx": 3557,
	"./Izydite/ru.mdx": 29325,
	"./MalajaEktenia/ru.mdx": 47218,
	"./MalijVhod/ru.mdx": 50707,
	"./MirTebeApostol/ru.mdx": 92591,
	"./MirTebeBlag/ru.mdx": 23759,
	"./Molitva1/ru.mdx": 76112,
	"./Molitva2/ru.mdx": 12861,
	"./Molitva3/ru.mdx": 41930,
	"./Oglashaemie/ru.mdx": 4322,
	"./OglashaemieVasiliy/ru.mdx": 16733,
	"./OtpustOglashaemie/ru.mdx": 80639,
	"./PredMalijVhod/ru.mdx": 24966,
	"./PremBeforeGospel/ru.mdx": 33784,
	"./Priugotovl/ru.mdx": 32246,
	"./Prokimens/Sunday/Glas1/ru.mdx": 50109,
	"./Prokimens/Sunday/Glas2/ru.mdx": 19248,
	"./Prokimens/Sunday/Glas3/ru.mdx": 11811,
	"./Prokimens/Sunday/Glas4/ru.mdx": 52414,
	"./Prokimens/Sunday/Glas5/ru.mdx": 24353,
	"./Prokimens/Sunday/Glas6/ru.mdx": 47572,
	"./Prokimens/Sunday/Glas7/ru.mdx": 38583,
	"./Prokimens/Sunday/Glas8/ru.mdx": 57842,
	"./Prokimens/WeekDays/1/ru.mdx": 84871,
	"./Prokimens/WeekDays/2/ru.mdx": 82702,
	"./Prokimens/WeekDays/3/ru.mdx": 99153,
	"./Prokimens/WeekDays/4/ru.mdx": 34688,
	"./Prokimens/WeekDays/5/ru.mdx": 4691,
	"./Prokimens/WeekDays/6/ru.mdx": 56474,
	"./Reading/ru.mdx": 7091,
	"./SugubajaEktenia/ru.mdx": 86130,
	"./Trisvatoe/GospoduPomolimsa/ru.mdx": 88379,
	"./Trisvatoe/MolitvaPered/ru.mdx": 55135,
	"./Trisvatoe/MolitvaPeredOk1/ru.mdx": 76678,
	"./Trisvatoe/MolitvaPeredOk2/ru.mdx": 78975,
	"./Trisvatoe/MolitvaPeredOk3/ru.mdx": 60604,
	"./Trisvatoe/PeredTrisvatoe/ru.mdx": 14414,
	"./Trisvatoe/Trisvatoe/ru.mdx": 20064,
	"./Userdnaya/ru.mdx": 28713,
	"./Usopshiye/ru.mdx": 61054,
	"./VelikajaEktenia/ru.mdx": 11015,
	"./VhodnoiStih/Budni/ru.mdx": 81865,
	"./VhodnoiStih/Sunday/ru.mdx": 7387,
	"./Vozglas/ru.mdx": 67811,
	"./Zaupokoynaya/ru.mdx": 61238
};



function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then((id) => (__webpack_require__(id)));
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | mdx-liturgy-katekhumen-ru */ 39917).then(() => {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 39029;
module.exports = webpackAsyncContext;